// Module
var code = "<div ui-view></div>";
// Exports
module.exports = code;